import { render, staticRenderFns } from "./QuotationStatusStepper.vue?vue&type=template&id=630ccbe6&scoped=true"
import script from "./QuotationStatusStepper.vue?vue&type=script&lang=js"
export * from "./QuotationStatusStepper.vue?vue&type=script&lang=js"
import style0 from "./QuotationStatusStepper.vue?vue&type=style&index=0&id=630ccbe6&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "630ccbe6",
  null
  
)

export default component.exports